import React from 'react';

const Admin = () => (
  <div className="site-card-wrapper pr-4 pl-4 pt-4">
    This page is intentionally left blank. Please, use the sub menu options to access admin only features for this account.
  </div>
);

export default Admin;
